import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/SelectPanel/SelectPanel.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A `}<inlineCode parentName="p">{`SelectPanel`}</inlineCode>{` provides an anchor that will open an overlay with a list of selectable items, and a text input to filter the selectable items`}</p>
    <h2>{`Example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`function getColorCircle(color) {
  return function () {
    return (
      <Box
        borderWidth="1px"
        borderStyle="solid"
        bg={color}
        borderColor={color}
        width={14}
        height={14}
        borderRadius={10}
        margin="auto"
      />
    )
  }
}

const items = [
  {leadingVisual: getColorCircle('#a2eeef'), text: 'enhancement', id: 1},
  {leadingVisual: getColorCircle('#d73a4a'), text: 'bug', id: 2},
  {leadingVisual: getColorCircle('#0cf478'), text: 'good first issue', id: 3},
  {leadingVisual: getColorCircle('#ffd78e'), text: 'design', id: 4},
  {leadingVisual: getColorCircle('#ff0000'), text: 'blocker', id: 5},
  {leadingVisual: getColorCircle('#a4f287'), text: 'backend', id: 6},
  {leadingVisual: getColorCircle('#8dc6fc'), text: 'frontend', id: 7},
]

function DemoComponent() {
  const [selected, setSelected] = React.useState([items[0], items[1]])
  const [filter, setFilter] = React.useState('')
  const filteredItems = items.filter(item => item.text.toLowerCase().startsWith(filter.toLowerCase()))
  const [open, setOpen] = React.useState(false)

  return (
    <SelectPanel
      renderAnchor={({children, 'aria-labelledby': ariaLabelledBy, ...anchorProps}) => (
        <Button trailingAction={TriangleDownIcon} aria-labelledby={\` \${ariaLabelledBy}\`} {...anchorProps}>
          {children || 'Select Labels'}
        </Button>
      )}
      placeholderText="Filter Labels"
      open={open}
      onOpenChange={setOpen}
      items={filteredItems}
      selected={selected}
      onSelectedChange={setSelected}
      onFilterChange={setFilter}
      showItemDividers={true}
      overlayProps={{width: 'small', height: 'xsmall'}}
    />
  )
}

render(<DemoComponent />)
`}</code></pre>
    <h2>{`Accessibility`}</h2>
    <h3>{`Keyboard`}</h3>
    <p>{`Pressing `}<inlineCode parentName="p">{`Enter`}</inlineCode>{` or `}<inlineCode parentName="p">{`Space`}</inlineCode>{` on the `}<inlineCode parentName="p">{`SelectPanel`}</inlineCode>{` anchor will
open the `}<inlineCode parentName="p">{`SelectPanel`}</inlineCode>{` and place focus on the filter input. Pressing `}<inlineCode parentName="p">{`Escape`}</inlineCode>{` or interacting with the cancel or close buttons will close the `}<inlineCode parentName="p">{`SelectPanel`}</inlineCode>{` and restore focus to the anchor.`}</p>
    <p>{`A user may use `}<inlineCode parentName="p">{`Tab`}</inlineCode>{` and `}<inlineCode parentName="p">{`Shift+Tab`}</inlineCode>{` to navigate between the filter input, list of
items, action buttons, and the close button.`}</p>
    <p>{`When focus is on the list of items, pressing `}<inlineCode parentName="p">{`ArrowDown`}</inlineCode>{` and `}<inlineCode parentName="p">{`ArrowUp`}</inlineCode>{` will allow navigation between items. Support for `}<inlineCode parentName="p">{`Home`}</inlineCode>{` and `}<inlineCode parentName="p">{`End`}</inlineCode>{` is also provided to quickly navigate to the first and last items in the list, respectively. Pressing `}<inlineCode parentName="p">{`Space`}</inlineCode>{` will select an item.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`Enter`}</inlineCode>{` key may be used when focus is within the `}<inlineCode parentName="p">{`SelectPanel`}</inlineCode>{` as an
alternative to activating the save button.`}</p>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: false,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      